<script setup lang="ts">
import Icon from './Icon.vue'
import ScrollAnimate from './ScrollAnimate.vue'
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()
</script>

<template>
  <section id="download" class="py-20 bg-base-100">
    <div class="max-w-4xl mx-auto px-4 text-center">
      <ScrollAnimate as="div">
        <h2 class="text-3xl md:text-4xl font-bold text-base-content">{{ t('download.title') }}</h2>
        <p class="text-lg text-base-content/70 mt-4 mb-8">
          {{ t('download.subtitle') }}
        </p>

        <a
          href="https://github.com/Wolido/OpenAaaS/releases"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary btn-lg btn-shine"
        >
          <Icon name="download" iconClass="w-6 h-6" />
          {{ t('download.button') }}
        </a>

        <p class="text-sm text-base-content/50 mt-4">
          {{ t('download.note') }}
        </p>
      </ScrollAnimate>
    </div>
  </section>
</template>
